import { render, staticRenderFns } from "./APIUserToken.vue?vue&type=template&id=2cb18196&scoped=true&"
import script from "./APIUserToken.vue?vue&type=script&lang=js&"
export * from "./APIUserToken.vue?vue&type=script&lang=js&"
import style0 from "./APIUserToken.vue?vue&type=style&index=0&id=2cb18196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb18196",
  null
  
)

export default component.exports